"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Equality = exports.NotEqualOperation = void 0;

var Operand_1 = require("./Operand");

var NotEqualOperation =
/** @class */
function (_super) {
  __extends(NotEqualOperation, _super); //EqualOperator: Equality;


  function NotEqualOperation(objEquality) {
    return _super.call(this) || this; // if (objEquality) {
    //     this.EqualOperator = objEquality;
    // }
    // else {
    //     this.EqualOperator = Equality.Equal;
    // }
  }

  NotEqualOperation.prototype.notEqualOperand = function (name, value, type) {
    _super.prototype.abstractOperandType.call(this, name, value, type); //this.EqualOperator = objEquality;

  };

  return NotEqualOperation;
}(Operand_1.Operand);

exports.NotEqualOperation = NotEqualOperation;
var Equality;

(function (Equality) {
  Equality[Equality["None"] = 0] = "None";
  Equality[Equality["Equal"] = 1] = "Equal";
  Equality[Equality["LessThan"] = 2] = "LessThan";
  Equality[Equality["GreaterThan"] = 3] = "GreaterThan";
  Equality[Equality["NotEqual"] = 4] = "NotEqual";
  Equality[Equality["GreaterThanOrEqual"] = 5] = "GreaterThanOrEqual";
  Equality[Equality["LessThanOrEqual"] = 6] = "LessThanOrEqual";
})(Equality = exports.Equality || (exports.Equality = {}));

;